export const STATS_CARD_BACKGROUND_COLOR = 'var(--gray-900)';
